var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsediconsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1250.43 107.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,58.14V1.78h32.55v53.7c0,10.95,4.88,20.56,18.49,20.56h19.97c13.76,0,18.49-9.62,18.49-20.56V1.78h32.55v56.36c0,32.1-19.38,48.97-51.04,48.97h-19.97C19.38,107.1,0,90.24,0,58.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.03,71.16c0,21.3-15.09,35.8-49.85,35.95h-22.04c-41.42,0-48.23-23.08-48.23-36.98h32.69c.89,5.18,7.1,7.99,17.6,7.99h19.97c11.69,0,16.57-2.37,16.57-6.36,0-2.96-2.51-5.47-10.06-5.47h-36.39c-25.74,0-38.76-11.83-38.76-30.18S150.22.15,186.76,0h21.01c41.87,0,47.04,25.89,47.04,35.95h-32.69c-.59-4.29-4.59-7.99-15.24-7.99h-20.12c-12.28,0-15.09,3.4-15.09,6.51s2.51,5.47,9.17,5.47h38.91c24.56,0,37.28,12.87,37.28,31.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.96,29.88v10.36h61.39v26.92h-61.39v9.91h71.45v28.26h-104V1.78h104v28.11h-71.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.53,53.55c0,31.95-24.56,51.78-56.95,51.78h-65.24V1.78h65.24c32.4,0,56.95,19.68,56.95,51.78ZM485.39,53.55c0-13.31-10.06-23.37-23.82-23.37h-32.84v46.75h32.84c13.76-.3,23.82-10.21,23.82-23.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.06,1.78h32.55v103.55h-32.55V1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.08,60.8h33.73c-3.25,27.96-25.74,46.3-56.36,46.3h-19.97c-32.4,0-56.81-21.45-56.81-53.55S651.33,0,684.47,0h19.97c30.62,0,53.11,18.34,56.36,46.3h-33.73c-2.96-9.02-11.39-15.98-22.63-15.98h-19.97c-14.05,0-23.67,9.91-23.67,23.23s9.62,23.67,23.67,23.67h19.97c11.24,0,19.67-7.25,22.63-16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.62,53.55c0,32.1-23.67,53.55-56.81,53.55h-19.97c-32.4,0-56.81-21.45-56.81-53.55S794.71,0,827.85,0h19.97c33.14,0,56.81,21.6,56.81,53.55ZM871.49,53.55c0-13.31-9.62-23.23-23.67-23.23h-19.97c-14.05,0-23.67,9.91-23.67,23.23s9.62,23.23,23.67,23.23h19.97c14.05,0,23.67-9.76,23.67-23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1043.53,1.78v103.55h-31.95l-59.77-57.84v57.84h-31.95V1.78h31.95l59.77,57.1V1.78h31.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1179.82,71.16c0,21.3-15.09,35.8-49.85,35.95h-22.04c-41.42,0-48.23-23.08-48.23-36.98h32.69c.89,5.18,7.1,7.99,17.6,7.99h19.97c11.69,0,16.57-2.37,16.57-6.36,0-2.96-2.51-5.47-10.06-5.47h-36.39c-25.74,0-38.76-11.83-38.76-30.18S1073.01.15,1109.55,0h21.01c41.87,0,47.04,25.89,47.04,35.95h-32.69c-.59-4.29-4.59-7.99-15.24-7.99h-20.12c-12.28,0-15.09,3.4-15.09,6.51s2.51,5.47,9.17,5.47h38.91c24.56,0,37.28,12.87,37.28,31.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.99,9.86h-9.5v20.75h-9.04V9.86h-9.59V1.93h28.13v7.93ZM1250.43,1.93v28.69h-8.58v-15.68l-7.29,9.32-7.75-9.59v15.96h-8.58V1.93h8.58l7.75,9.5,7.29-9.5h8.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsediconsLogo);
export default __webpack_public_path__ + "static/media/USEDICONS-LOGO.9c2648675952fd4b9489cc65a34aebab.svg";
export { ForwardRef as ReactComponent };